module.exports = {
  global: {
    thousands_separator: ' ',
    profile: "Profil",
    over: "Dépassé",
    year: "An | Ans",
    month: "Mois",
    from: "Il y a",
    date: "Date",
    amount: "Montant",
    simulation: "Simulation",
    confirmation: "Confirmation",
    documents: "Documents",
    signature: "Signature",
    password: "Mot de passe",
    edit: "Modifier",
    male: "Monsieur",
    female: "Madame",
    lastname: "Nom",
    firstname: "Prénom",
    birthname: "Nom de naissance",
    mobile_phone: "Téléphone mobile",
    email_address: "Adresse email",
    more_informations: "Afficher plus d'informations",
    is: "Est de",
    in: "En",
    to: 'À',
    yes: 'Oui',
    no: 'Non',
    or: 'Ou',
    show_more_operations: "Afficher plus d'opérations",
    months: {
      january: "Janvier",
      february: "Février",
      march: "Mars",
      april: "Avril",
      may: "Mai",
      june: "Juin",
      july: "Juillet",
      august: "Août",
      september: "Septembre",
      october: "Octobre",
      november: "Novembre",
      december: "Décembre"
    },
    weekdays: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche"
    },
    select: "Sélectionner",
    years: "ans",
    and: "et",
    modify: "Modifier"
  },
  header_topbar: {
    back_to_member_dashboard: 'Retourner sur mon espace personnel'
  },
  errors: {
    404: {
      title: "404",
      content: "Cette page n'existe pas ou n'est plus active <br> Nous vous invitons à vérifier que l'adresse saisie soit bien correcte. "
    },
    500: {
      title: "500",
      content: "Une erreur est survenue. <br> Veuillez actualiser la page ou réessayer plus tard."
    }
  },
  terms: {
    matrimonial_kind: {
      0: "Célibataire",
      1: "Divorcé(e)",
      2: "Marié(e)",
      3: "Séparé(e)",
      4: "Union libre",
      5: "Veuf/Veuve",
      6: "Pacsé(e)"
    },
    risk_profile: {
      0: "Profil Garanti",
      1: "Défensif 1",
      2: "Défensif 2",
      3: "Équilibre 1",
      4: "Équilibre 2",
      5: "Équilibre 3",
      6: "Offensif 1",
      7: "Offensif 2",
      8: "Offensif 3",
      9: "Agressif 1",
      10: "Agressif 2"
    },
    asset_allocation: {
      equity_part: "Actions",
      fixed_income_part: "Produits à revenu fixe",
      euro_funds: "Fonds Euro",
      bonds: "Obligations",
      stocks: "Actions",
      raw_material: "Matières premières",
      other: "Alternatif"
    }
  },
  simulation: {
    mobile_nav: {
      simulation: "Simulation",
      profile: "Profil",
      confirmation: "Confirmation",
      documents: "Documents",
      signature: "Signature",
      member_space: "Espace membre",
      logout: "Déconnexion",
    },
    goals: {
      choose_your_investment_category: "Choisissez votre catégorie de placement",
      i_have_a_saving_project: "J'ai un projet d'épargne",
      saving_project_example: "(Retraite, Immobilier, Transmission, etc.)",
      i_dont_have_a_saving_project: "Je n'ai pas de projet précis",
      just_want_to_save: "(Je souhaite simplement épargner)",
      investment_category_explained: "Pour commencer, il vous suffit de choisir une catégorie de placement qui répond à vos besoins sans avoir pour le moment d'incidence sur les projections de vos simulations.",
      wesave_help_you_for_saving: "WeSave vous accompagne simplement pour épargner en définissant votre objectif, votre horizon de placement et votre profil d’épargnant.",
      simulate_saving_with_wesave: "Simulez votre épargne avec WeSave",
      our_simulator_allow_saving_evolution: "Notre simulateur vous permettra de visualiser les évolutions possibles de votre épargne",
      in_time_according_to_management: "dans le temps en fonction du mode de gestion choisi."
    },
    goals_defined: {
      contract_for_kid: "Ouvrez un contrat au nom de votre enfant.",
      contract_for_kid_desc: "L'épargne constituée lui appartiendra et il disposera d'un accès total à son compte à sa majorité.",
      contract_for_kid_warning: "Dans la simulation suivante, les questions portant sur le projet d'épargne WeSave Family concernent votre enfant. Néanmoins, les questions portant sur la connaissance des marchés financiers, l'appétence au risque, et le besoin de liquidité concernent le représentant légal gérant du contrat.",
      button_goals_undefined: "Vous n'avez pas de projet précis ?",
      validate: "Valider mon choix"
    },
    legend: {
      legend: 'Légende',
      target_amount: "Montant Cible",
      accumulate_payments: "Cumul de vos versements",
      over_performance: "Sur-performance (15%)",
      expected_performance: "Performance attendue (65%)",
      low_performance: "Faible performance (15%)",
      ultimate_goal: "Votre objectif à terme",
      financial_crisis: "Scénario crise financière *",
      view_simplified_view: "Afficher la vue simplifée",
      hide_simplified_view: "Masquer la vue simplifée",
      potential_gains_and_losses: "Gains et pertes potentiels"
    },
    settings: {
      description: "Renseignez les paramètres suivant pour visualiser la projection de votre épargne :",
      investment_category: "Ma catégorie de placement",
      investment_category_placeholder: "Séléctionnez une catégorie",
      choose_goal: "Choisissez un objectif pour votre projet d'épargne",
      amount_to_reach: "Mon montant à atteindre",
      how_much_reach: "Quel montant souhaitez-vous atteindre ?",
      remaining_investment_period: "Ma durée d'investissement :",
      investment_period: "Ma durée d'investissement :",
      my_scheduled_payments: "Mes versements mensuels :",
      contract_valuation_after_modification: 'Mon versement initial :',
      my_initial_payment: "Mon versement initial :",
      do_you_have_a_promotional_code: "Vous avez un code promotionnel ?",
      choose_the_most_appropriate_profile: "Choisissez la gestion la plus adaptée à votre profil :",
      popin: {
        enter_a_title: 'Titre',
        contract_for_kid: "Ouvrez un contrat au nom de votre enfant.",
        saving_for_kid_majority: "L'épargne constituée lui appartiendra et il disposera d'un accès total à son compte à sa majorité.",
        wesave_family_explained: "Dans la simulation suivante, les questions portant sur le projet d’épargne WeSave Family concernent votre enfant. Néanmoins, les questions portant sur la connaissance des marchés financiers, l’appétence au risque, et le besoin de liquidité concernent le représentant légal gérant du contrat.",
        validate: "Valider mon choix",
      },
      portfolio_info_basic: {
        time_investment: {
          less_than_or_equal_to: "La durée doit être inférieure à %{count} ans",
          greater_than_or_equal_to: "La durée doit être supérieure à une année"
        }
      },
      investment_horizon: "Quel horizon de placement envisagez-vous pour atteindre votre objectif ?",
      minimum_scheduled_payments: "En cas de versements programmés, le minimum est de",
      how_much_save_per_month: "Combien pensez-vous pouvoir épargner par mois ?",
      min_initial_amount: "Le montant minimum de versement est de",
      initial_amount: "Quel montant souhaitez-vous investir à l’ouverture de votre contrat ?",
      discount_promo_code: {
        title: "Code promotionnel",
        description: "Si vous avez un code promotionnel ou un code de parrainage, entrez-le ci-dessous :",
        label: "Code promotionnel",
        show_results: {
          title_first: "Le code ",
          title_second: " vous permet de souscrire à WeSave Patrimoine dès :",
          monthly_payment: "en versement mensuel",
          initial_amount: "en montant initial"
        }
      }
    },
    projection: {
      title: "En {year} (dans ",
      header: {
        change_your_settings: "Modifier vos paramètres",
        define_investor_profile: "Définir mon profil d'épargnant",
        nav: {
          projection: "Projection",
          allocation: "Allocation",
          description: "Description",
          performance: "Performance"
        }
      },
      projection_title: "Projection",
      legend: {
        format_amount_estimate: "de {inf} à {sup}",
        accumulate_payments: "Cumul de vos versements",
        performance_type: [
          {
            expected_performance: {
              title: "Performance attendue",
              subtitle: "(Très probable - 65%)"
            }
          },
          {
            over_performance: {
              title: "Sur-performance",
              subtitle: "(Peu probable - 15%)"
            }
          },
          {
            low_performance: {
              title: "Sous-performance",
              subtitle: "(Peu probable - 15%)"
            }
          }
        ],
        financial_crisis: "Scénario crise financière*"
      },
      investment_risk_warning: "L’investissement en unités de compte présente un risque de perte en capital.",
      investment_warning: "* Perte observée sur un portefeuille similaire à ce profil de risque depuis 2001. Cela correspond à la valeur du projet si une grave crise financière venait à se produire à l'échéance du projet.",
      loss_observed_on_a_similar_portfolio: "Perte observée sur un portefeuille similaire à ce profil de risque depuis 1996. Cela correspond à la valeur du projet si une grave crise financière venait à se produire à l'échéance du projet.",
      disclaimer_benchmark: "Les performances passées ne sont pas un indicateur fiable des performances futures. Les données calculées ci-dessus reposent, afin de rendre compte du rendement des Fonds Euro, sur une hypothèse d’un rendement régulier sur la durée de 1.5%. Pour les obligations souveraines, nous retenons une combinaison de 50% de l’indice Bloomberg Barclays US Treasury Index measures US dollar-denominated, de 30% de l’indice Bloomberg Barclays Euro Government, et de 20% de l’indice Bloomberg Barclays Emerging Markets Hard Currency Aggregate. Pour les obligations d’entreprises, une combinaison de 30% de l’indice Bloomberg Barclays Euro-Aggregate, de 30% de l’indice Bloomberg Barclays US Corporate Bond, de 20% de l’indice Bloomberg Barclays US Corporate High Yield Bond, de 10% de l’indice Bloomberg Barclays Global High Yield, et de 10% de l’indice Bloomberg Barclays Pan-European High Yield. Pour les actions monde, nous ne retenons que l’indice MSCI AC World Daily Total Return Net USD. Pour représenter les actions d’Amérique du nord, nous retenons une combinaison de 50% de l’indice S&P500 Total Return, et de 50% de l’indice NASDAQ-100 Total Return. Pour représenter les actions européennes, nous retenons la combinaison de 40% de l’indice STOXX Europe Total Market Growth (Net Return) EUR, de 30% de l’indice MSCI Europe Net Total Return EUR, et de 30% de l’indice FTSE EPRA Nareit Developed Europe. Pour représenter les actions asiatiques, nous retenons la combinaison de 50% de l’indice TOPIX 100 Total Return, et de 50% de l’indice Shanghai Stock Exchange Composite. Pour représenter les actions émergentes, nous ne retenons que l’indice MSCI Emerging Net Total Return USD. Pour représenter les matières premières, nous retenons une combinaison de 40% de l’indice Refinitiv/CoreCommodity CRB, de 30% de l’indice Philadelphia Stock Exchange Gold and Silver, et de 30% de l’indice European Crude Dated Brent Spot. Enfin, pour les actifs alternatifs, nous retenons la combinaison de 40% de l’indice Bloomberg Barclays US Govt Inflation-Linked All Maturities Total Return, de 30% de l’indice LPX Major Market Listed Private Equity, et de 30% de l’indice Chicago Board Options Exchange Volatility. Les pondérations affectées à chacune des classes d'actifs diffèrent sensiblement d'un profil à l'autre. Les rendements présentés ne donnent qu'une indication théorique des hauts et bas de marchés rencontrés par chacun des profils, et ne sont pas une garantie de performance. Source des données: Bloomberg"
    },
    allocation: {
      title: "Allocation type du portefeuille",
      description: "L'allocation proposée ici par WeSave ne se veut pas figée dans le temps. <strong>Une modification éventuelle de sa composition se fera en fonction de votre profil d'épargnant, de vos besoins ou des évolutions de marché.</strong> Nos portefeuilles évolueront en fonction de notre analyse de l'actualité, de notre sélection d'instruments financiers et de votre appétence au risque.",
      worldmap_repartition_title: "Répartition géographique"
    },
    performance: {
      title_over_last_5_years: "Sur les 5 dernières années",
      same_portfolio_performance: "Performance d'un portefeuille comparable*",
      over_last_5_years: "sur les 5 dernières années",
      average_yield_portfolio: "Le rendement moyen annualisé d'un portefeuille comparable",
      disclaimer: "L’investissement en unités de compte présente un risque de perte en capital.",
      wihch_is_the_best_calendar_perf: ", qui correspond à la meilleure performance calendaire, ce portefeuille a obtenu un rendement de",
      wihch_is_the_worst_calendar_perf: ", qui correspond à la pire performance calendaire, ce portefeuille a obtenu un rendement de",
      title_last_years: "Sur les {years} dernières années",
      over_the_last: "sur les",
      last_years: "dernières années"
    },
    incoherent_project_modal: {
      situation_information: "Vous avez un objectif de <strong>{objective}</strong> avec un horizon de <strong>{years} ans</strong>.",
      this_project_seems_too_optimistic: "Ce projet semble trop optimiste",
      this_project_seems_too_optimistic_desc: "Modifiez vos versements mensuels, votre durée d'investissement ou votre objectif financier pour que votre projet soit réalisable :",
      this_project_seems_incoherent: "Ce projet semble incohérent",
      this_project_seems_incoherent_desc: "Les paramètres que vous avez renseignés vous permettent d'atteindre un objectif financier plus pertinent.",
      change_my_monthly_effort: "Changer mes versements mensuels",
      change_my_investment_term: "Changer ma durée d'investissement",
      change_my_goal: "Changer mon montant à atteindre",
      increase_amount: "Remonter mon montant à atteindre",
    },
    risk_alert: {
      title: "En êtes-vous sûr(e) ?",
      over: {
        disclaimer: "D'après vos réponses aux questions et l'horizon de placement déterminé, ce profil de gestion ne correspond pas à votre profil de risque. Le niveau de risque et de volatilité sont effectivement plus élevés et pourraient engendrer un désinvestissement prématuré de votre part en cas de fortes fluctuations sur les marchés financiers. De plus, si votre horizon de placement est trop limité, vous pourriez subir de fortes pertes en cas de retournement des marchés, sans avoir le temps nécessaire d'y remédier.",
        answers: [
          "Ce placement représente une part peu importante de mon patrimoine.",
          "Pour cet investissement précis, je veux prendre plus de risque car j'en espère un meilleur rendement.",
          "Dans le cas d'un investissement à court terme, j'ai compris et accepte que mon capital puisse subir de fortes baisses et/ou hausses, se traduisant potentiellement en perte de capital."
        ],
        accept: "En poursuivant, je reconnais avoir pris connaissance, et compris que le risque que je prends est plus élevé que le profil de risque que je viens de déterminer. Par conséquent, je m'expose potentiellement à de plus fortes pertes en capital."
      },
      under: {
        disclaimer: "D'après le profil de risque déterminé et l'horizon de placement souhaité, un tel profil de gestion, correspondant à un niveau de rendement espéré moins élevé, pourrait être trop prudent pour atteindre votre objectif.",
        answers: [
          "Je souhaite simplement prendre moins de risque avec mon argent pour cet objectif patrimonial.",
          "Je préfère dans un premier temps tester WeSave Patrimoine."
        ],
        accept: "En poursuivant, je reconnais avoir pris connaissance, et compris que le profil de gestion choisi est moins risqué."
      },
      justification: {
        title: "Si vous souhaitez confirmer ce profil de gestion, merci de nous en préciser la raison :",
        other: "Pour toute autre raison :"
      },
      resume: "Continuer"
    },
    loss_recap_popin: {
      win_loss: "Gains et pertes potentiels pour cet objectif :",
      accumulate_payments: "Cumul avec vos versements",
      expected_average_performance: "Performance moyenne attendue",
      bad_performances: "Mauvaise performance possible",
      max_drawdown: "Scénario de crise financière pour un profil similaire (Max Drawdown) **",
      saving_inf: "* Il y a 2.5% de chance que l'épargne atteinte soit inférieure à la valeur du scénario pessimiste.",
      warning: "** Perte observée sur un portefeuille similaire à ce profil de risque depuis 2001. Cela correspond à la valeur du projet si une grave crise financière venait à se produire à l'échéance du projet. Performance observée sur un portefeuille simulaire en 2008 (scénario de crise)",
      no_contractual_value: "Cette simulation n'a aucune valeur contractuelle et ne saurait présager des performances futures. Elle est basée sur les mêmes hypothèses que la simulation précédente. L'investissement en unités de compte comporte un risque de perte en capital.",
      table_is_projection: "J'ai compris ce tableau de projection de gains et pertes potentiels établi en fonction des informations saisies dans ma simulation.",
      observed_losses: "Perte observée sur un portefeuille similaire à ce profil de risque depuis 1996. Cela correspond à la valeur du projet si une grave crise financière venait à se produire à l'échéance du projet.",
      simulation_no_contractual_value: "Cette simulation n'a aucune valeur contractuelle et ne saurait présager des performances futures. Elle est basée sur les mêmes hypothèses que la simulation précédente. L'investissement en unités de compte comporte un risque de perte en capital.",
      modify_objective: "Modifier mon objectif",
      confirm_objective: "Confirmer cet objectif",
      continue_with_profile: "Continuer avec le profil",
      cancel: "Modifier",
      resume: "Continuer",
      close: "Fermer"
    },
    profile_analysis: {
      current_profile: "Profil actuel",
      chosen_profile: "Profil choisi",
    },
    simplified_view_popin: {
      your_goal: "Votre objectif :",
      your_payement: "Vos versements",
      crisis_scenario: "Scénario de crise :",
      probability_of_being_over_your_payments: "% de probabilité d’être au dessus de vos versements",
      more_than_probability: "Plus de 97.5% de probabilités d’être au dessus de vos versements",
      less_than_probability: "Moins de 2.5% de probabilités d’être en dessous de vos versements",
      saving_value_between: ", il est très probable que la valeur de votre épargne soit comprise entre",
    },
    onboarding: {
      saving_simulation: "Simulez votre projet d'épargne",
      discover_saving_with_profil: "Découvrez votre épargne avec le profil",
      confirm_saving_with_profil: "Confirmez votre projet avec le profil",
      project_realistic_or_not_explain: "Votre projet est il réaliste ou inenvisageable? Une fois avoir renseigné les paramètres sur votre gauche, il vous est facile d'ajuster votre projection en fonction du profil de risque ou de l'horizon de placement, par exemple.",
      nav: {
        projection: "Projection",
        allocation: "Allocation",
        description: "Description",
        performance: "Performance"
      }
    },
    risk_profile: {
      scroll_down_for_more_information: "Faites défiler la page pour plus d'informations",
      choose_the_most_appropriate_profile: "Choisissez la gestion la plus adaptée à votre profil :",
      confirm_your_risk_profile: "Confirmez votre profil de risque :",
      choose_a_profile: "Choisissez un profil de risque pour votre gestion",
      director_of_investments: "Directeur des investissements",
      find_explanation: "Retrouvez l’explication de notre gérant sur ce profil dans",
      description_tab: "l’onglet Description",
      no_obligation: "Cette simulation ne comporte aucune obligation de souscription ultérieure, et n’implique en rien les performances futures",
      disclaimer: " Attention si vous changez de profil de risque vous ne pourrez plus retourner en profil de risque P0 étant donné que ce contrat n’est plus commercialisé par Wesave.",
      save_simulation: "Sauvegarder ma simulation",
      continue: "Continuer"
    },
    education: {
      capital_allocation: "Répartition du capital",
      euro_funds: "Fonds en Euros",
      account_units: "Unités de Compte",
      euro_funds_is_guarantee: "Le <span>100% fonds en euros</span> est garantie en capital.",
      euro_funds_may_changes: "Le pourcentage de <span>fonds en euros</span> peut varier de +/- 10% selon la vision tactique Wesave.",
      no_guarantee: "La part de fonds en euros, comme la part en unités de compte, <strong>n'est pas garantie en capital</strong>.",
      distribution_of_units_of_account: "Répartition des Unités de Compte",
      mederate_risk: "Fonds <span>faiblement ou modérément</span> risqués (au moins)",
      risked_funds: "Fonds <span>risqués</span> (au plus)",
      low_risk_funds_srri: "Les <span>fonds faiblement ou modérément risqués</span> correspondent au fonds dont le <strong>SRRI est inférieur à 4</strong>.",
      risked_funds_srri: "Les <span>fonds risqués</span> correspondent au fonds dont le <strong>SRRI est supérieur à 4.</strong>",
      profil_description: "Description du Profil",
      euro_fund_description: "Le fonds en euros Suravenir Rendement adossé à l’Actif Général de Suravenir vise, au travers de son allocation d’actifs majoritairement obligataires, à privilégier la sécurité et la récurrence du rendement. Il bénéficie chaque année d’une revalorisation correspondant à la participation aux bénéfices.",
      profil_1_description: "Le souscripteur du Profil 1 souhaite bénéficier d’une gestion adaptée à un très faible niveau de risque.<br>Voulant limiter les pertes, 55% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRRI, présenté dans le DICI ne dépasse pas “4” sur l’échelle de “1 à 7”). 45% de votre épargne sera investi sur le fonds en euros.<br> En dehors de toute considération fiscale, il est recommandé de maintenir les investissements durant une période d’au moins 2 ans pour ce type de profil.",
      profil_2_description: "Le souscripteur du Profil 2 souhaite bénéficier d’une gestion adaptée à un très faible niveau de risque.<br> Voulant limiter les pertes, 60% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRRI, présenté dans le DICI ne dépasse pas “4” sur l’échelle de “1 à 7”). 40% de votre épargne sera investi sur le fonds en euros.<br> En dehors de toute considération fiscale, il est recommandé de maintenir les investissements durant une période d’au moins 2 ans pour ce type de profil.<br>",
      profil_3_description: "Dans un Profil 3, votre appétence et votre aversion au risque sont proches. Vous ne cherchez pas particulièrement à préserver votre capital à tout prix, de la même façon que vous ne courrez pas après un rendement très élevé. Vous êtes prêts à accepter une prise de risque si celle-ci est justifiée par un retour sur investissement.<br> Ainsi, 65% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRRI, présenté dans le DICI ne dépasse pas “4” sur l’échelle de “1 à 7”). 35% de votre épargne sera investie sur le fonds en euros.<br>",
      profil_4_description: "Dans un Profil 4, votre appétence et votre aversion au risque sont équivalentes. Vous ne cherchez pas particulièrement à préserver votre capital à tout prix, de la même façon que vous ne courrez pas après un rendement élevé. Vous êtes prêts à accepter une prise de risque si celle-ci est justifiée par un retour sur investissement en conséquence.<br> Ainsi, 70% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRRI, présenté dans le DICI ne dépasse pas “4” sur l’échelle de “1 à 7”). 30% de votre épargne sera investie sur le fonds en euros.",
      profil_5_description: "Dans un Profil 5, votre appétence et votre aversion au risque sont équivalentes. Vous ne cherchez pas particulièrement à préserver votre capital à tout prix, de la même façon que vous ne courrez pas après un rendement élevé. Vous êtes prêts à accepter une prise de risque si celle-ci est justifiée par un retour sur investissement en conséquence.<br> Ainsi, 75% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRRI, présenté dans le DICI ne dépasse pas “4” sur l’échelle de “1 à 7”). 25% de votre épargne sera investie sur le fonds en euros.",
      profil_6_description: "Dans un Profil 6, votre appétence au risque est assez forte. Vous êtes conscient que votre capital peut fluctuer à la hausse comme à la baisse dans d’assez fortes proportions. De même, vous acceptez une prise de risque pour espérer des gains plus importants dans le temps.<br> 80% de votre épargne sera investie sur des Unités de compte dont le niveau de risque (mesuré par l’indice SRRI présenté dans le DICI du fonds) fluctuera selon les phases de marchés. Néanmoins, 20% de votre épargne sera investie sur le fonds en euros.",
      profil_7_description: "Dans un Profil 7, votre appétence au risque est forte. Vous êtes conscient que votre capital peut fluctuer à la hausse comme à la baisse dans de fortes proportions. De même, vous acceptez une prise de risque pour espérer des gains plus importants dans le temps.<br> 85% de votre épargne sera investie sur des Unités de compte dont le niveau de risque (mesuré par l’indice SRRI présenté dans le DICI du fonds) fluctuera selon les phases de marchés. Néanmoins, 15% de votre épargne sera investie sur le fonds en euros.",
      profil_8_description: "Dans un Profil 8, votre appétence au risque est très forte. Vous êtes conscient que votre capital peut fluctuer à la hausse comme à la baisse dans de fortes proportions. De même, vous acceptez une prise de risque pour espérer des gains plus importants dans le temps.<br>90% de votre épargne sera investie sur des Unités de compte dont le niveau de risque (mesuré par l’indice SRRI présenté dans le DICI du fonds) fluctuera selon les phases de marchés. Néanmoins, 10% de votre épargne sera investie sur le fonds en euros.",
      profil_9_description: "Dans un Profil 9, vous souhaitez prendre des risques dans le but d'optimiser l'espérance de retour sur investissement de votre placement. Vous êtes conscient que votre placement est soumis de façon importante aux fluctuations des marchés financiers, et êtes prêt à ne pas prendre de décision hâtive en cas de forte baisse des marchés.<br>95% de votre épargne sera investie sur des Unités de compte afin de dynamiser la performance de votre contrat. Le niveau de risque, mesuré par l’indice SRRI présenté dans les DICI des fonds, pourra être important.",
      profil_10_description: "Dans un Profil 10, vous souhaitez prendre des risques dans le but d'optimiser l'espérance de retour sur investissement de votre placement. Vous êtes conscient que votre placement est soumis de façon très importante aux fluctuations des marchés financiers, et êtes prêt à ne pas prendre de décision hâtive en cas de très forte baisse des marchés.<br>100% de votre épargne sera investie sur des Unités de compte afin de dynamiser la performance de votre contrat. Le niveau de risque, mesuré par l’indice SRRI présenté dans les DICI des fonds, pourra être très important.",
    },
    simulation_chart: {
      fill_settings_to_view_projection: "Remplissez les paramètres sur la gauche pour visualiser la projection de votre épargne.",
      your_project_is_not_realist: "Votre projet n'est pas réalisable",
      click_here_to_reajust: "Cliquez-ici pour le réajuster",
      change_my_monthly_effort: "Changer mon effort mensuel",
      euro_per_month: " €/mois",
      change_my_investment_term: "Changer ma durée d'investissement",
      change_my_goal: "Changer mon objectif",
      this_project_seems_too_optimistic: "Ce projet semble trop optimiste",
      this_project_seems_incoherent: "Ce projet semble incohérent",
      raise_my_goal: "Remonter mon objectif",
    },
    confirmation_popin: {
      title: "En êtes-vous sûr(e) ?",
      adapted_title: "Vous avez choisi un niveau de risque adapté à votre profil",
      justification: {
        title: "Si vous souhaitez confirmer ce profil de gestion, merci de nous en préciser la raison :",
        over: {
          disclaimer: "D’après vos réponses aux questions et l’horizon de placement déterminé, ce profil de gestion ne correspond pas à votre profil de risque. Le niveau de risque et de volatilité sont effectivement plus élevés et pourraient engendrer un désinvestissement prématuré de votre part en cas de fortes fluctuations sur les marchés financiers. De plus, si votre horizon de placement est trop limité, vous pourriez subir de fortes pertes en cas de retournement des marchés, sans avoir le temps nécessaire d’y remédier.",
          accept: "En poursuivant, je reconnais avoir pris connaissance, et compris que le risque que je prends est plus élevé que le profil de risque que je viens de déterminer. Par conséquent, je m'expose potentiellement à de plus fortes pertes en capital.",
          tooltip: {
            1: "Il est important de prendre en compte l’évolution de ce placement : en effet s’il venait à représenter une part importante de votre patrimoine il sera nécessaire de reconsidérer le profil de gestion choisi.",
            2: "Attention, dans la plupart des cas où l’investisseur choisit un profil de risque plus élevé qu’il ne le tolère réellement, il désinvestit fréquemment son capital en cas de baisse des marchés financiers, ne laissant pas le temps de rebondir à son placement et entérinant ainsi les pertes latentes.",
            3: "Si vous souhaitez investir sur un objectif à court terme, nous vous recommandons d’opter pour un profil de gestion plus sécurisé et moins volatile. En effet en cas de marchés baissiers, il est essentiel d’avoir une vision suffisamment longue pour laisser le temps à votre investissement de recouvrir ses pertes.",
          },
          helper_label: {
            1: "Ce placement représente une part peu importante de mon patrimoine.",
            2: "Pour cet investissement précis, je veux prendre plus de risque car j’en espère un meilleur rendement.",
            3: "Dans le cas d’un investissement à court terme, j’ai compris et accepte que mon capital puisse subir de fortes baisses et/ou hausses, se traduisant potentiellement en perte de capital.",
            4: "Pour toute autre raison :",
          }
        },
        under: {
          disclaimer: "D’après le profil de risque déterminé et l’horizon de placement souhaité, un tel profil de gestion, correspondant à un niveau de rendement espéré moins élevé, pourrait être trop prudent pour atteindre votre objectif.",
          accept: "En poursuivant, je reconnais avoir pris connaissance, et compris que le profil de gestion choisi est moins risqué.",
          tooltip: {
            1: "Il peut être légitime et judicieux de limiter la prise de risque sur le capital que vous investissez. Il faut cependant être conscient que le rendement espéré paraîtra d’autant plus faible sur ce profil de gestion compte tenu de l’inflation.",
            2: "Très bien, sachez que vous êtes libre de changer de profil de gestion à tout moment sans frais supplémentaires (exceptés 0.1% des sommes arbitrés au titre des frais de courtage des ETF). Au-delà de votre profil de risque, il est également important de tenir compte de votre horizon de placement. En effet plus la durée d’investissement est longue, plus les marchés financiers ont le temps de combler d’éventuelles baisses subies précédemment. N’hésitez à utiliser notre simulateur pour en mesurer l’impact.",
          },
          helper_label: {
            1: "Je souhaite simplement prendre moins de risque avec mon argent pour cet objectif patrimonial.",
            2: "Je préfère dans un premier temps tester WeSave Patrimoine.",
            3: "Pour toute autre raison :",
          }
        }
      },
      continue: "Continuer vers le récapitulatif",
      cancel: "Annuler",
      continue_to_summary: "Continuer vers le récapitulatif",
    },
    recap: {
      your_simulation: "Simulation de votre projet",
      initial_payement: "Versement initial",
      monthly_payement: "Versements mensuels",
      objective: "Objectif",
      project_real: "Réalisation de mon projet",
      percent_real: "% de réalisation",
      change_simulation: "Modifier la simulation de mon projet",
      time_investment: "Durée d'investissement",
      accompaniment: "Bénéficiez d'un <strong>accompagnement sur-mesure</strong> pour définir au mieux votre projet <span id=\"recap-project-name2\"></span> en contactant <strong>dès maintenant</strong> votre conseiller dédié.",
      descriptions: [
        "Impôts, achat d’une voiture, travaux: ces dépenses prévues ou imprévues représentent un réel budget qu’il vous faut anticiper. Or, si cet argent doit rester disponible à tout moment, il ne doit pas pour autant dormir sur un compte en banque et ne rien vous rapporter.",
        "Vous n’avez pas de projet en particulier? Vous avez reçu un héritage ou gagné une somme d’argent importante et vous souhaitez faire fructifier ce capital? Ne laissez pas votre argent dormir sur des comptes à faible rendement. Faites le choix d’une épargne performante dont les risques sont maîtrisés.",
        "Allongement des durées de cotisations, baisse des pensions : prévoir votre retraite et anticiper votre perte de revenu est important, et le faire dès maintenant est primordial ! C'est au cours de votre vie active que vous devez construire le capital qui constituera votre complément de revenu.",
        "Aujourd’hui, obtenir le financement d’un projet d’investissement immobilier peut vite se transformer en parcours du combattant. C’est pourquoi, il vous faut construire un solide plan de financement. Apport personnel, offre de prêt, taux d’intérêt, garanties, assurances, ...vous devez tout prévoir.",
        "Rien de plus normal que de faire profiter votre famille de votre patrimoine et de lui assurer un avenir après votre disparition. Cela demande une analyse de votre structure familiale, de votre patrimoine (commun ou personnel), de vos objectifs et du cadre légal (imposition, droits de succession).",
        "Frais de scolarité ou de vie étudiante: les études de vos enfants représentent bien souvent un énorme effort financier. Pour ne pas faire de sacrifice, il est important d’y penser dès maintenant.",

      ]
    },
  },
  sentences: {
    project_creation_state: {
      0: "Réalisez une simulation afin de définir votre nouvel objectif",
      1: "Renseignez vos informations pour définir votre profil d'épargnant",
      2: "Confirmez la simulation de votre objectif",
      3: "Importez vos documents administratifs",
      4: "Signez électroniquement votre demande de contrat"
    }
  },
  sidebar: {
    home: "Mes projets d'épargne",
    transfers: "Opérations",
    gestion: "Ma gestion",
    sponsorship: "Parrainage",
    sponsorship_code: "Votre code parrain :",
    blog: "Le blog de WeSave",
    immo: "Wesave Immo",
    warning: "Cette page ne vous sera accessible que lorsque votre premier contrat sera validé par notre partenaire assureur.",
    new_project: {
      title: "Un nouveau projet en vue ?",
      button: "Démarrer un nouveau projet"
    },
    projects_overview: {
      title: "Réalisation de vos projets"
    },
    goals: {
      0: "Épargne de précaution",
      1: "Accroissement de capital",
      2: "Retraite",
      3: "Immobilier",
      4: "Transmission",
      5: "Avenir de mes enfants",
      6: "WeSave Family",
      "-1": "Autres",
    },
    registration: {
      simulate_project: "Simulez vos <br> projets d'épargne",
      fill_in_profile: "Renseignez <br> votre profil",
      confirm_project: "Confirmez votre <br> projet d'épargne",
      import_documents: "Importez vos documents <br> administratifs",
      sign_documents: "Signez électroniquement <br> votre demande de souscription",
    }
  },
  profile: {
    title: "Mon profil : {firstname} {lastname}",
    desc: "Paramétrez vos préférences, mettez à jour vos informations et retrouvez les documents à télécharger concernant vos différents contrats.",
    sidebar: {
      profile: "Mon profil",
      help: "Aide (FAQ)",
      logout: "Déconnexion",
    },
    nav: {
      user: "Personnel",
      documents: "Pièces justificatives",
      downloads: "Documents téléchargeables"
    },
    user_profile: {
      infos: {
        address: "Adresse :",
        email: "Email :",
        mobile_phone: "Téléphone mobile :",
        modification_information: "Pour modifier vos coordonnées (adresse, téléphone, email), veuillez prendre contact avec votre conseiller :",
        coordinates: {
          part_1: "En appelant le ",
          part_2: " du lun. au ven. de 9h à 18h ou par email à "
        }
      },
      about_me: {
        title: "À propos de moi",
        date_of_birth: "Date de naissance :",
        nationality: "Nationalité :",
        country_of_birth: "Pays de naissance :",
        birthplace: "Ville de naissance :",
        marital_status: "Statut marital :",
        matrimonial_regime: "Régime matrimonial :",
        dependent_children: "Enfants à charge :",
        professional_status: "Statut professionnel :",
        socio_professional_category: "Catégorie Socio-professionnelle :",
        profession: "Profession :"
      },
      patrimony: {
        title: "Mon patrimoine",
        source_of_revenue: "Source de revenus :",
        annual_net_household_income: "Revenus annuels nets de votre foyer :",
        annual_savings_capacity: "Capacité d’épargne annuelle :",
        estimate_your_patrimony: "Estimation de votre patrimoine :",
        allocation_your_patrimony: "Répartition de votre patrimoine",
        financial_patrimony: "Patrimoine financier",
        estate_patrimony: "Patrimoine immobilier",
        other_patrimony: "Autre (Objets de collection, oeuvres d'art...)",
      },
      legal_status: {
        title: "Situation juridique",
        legal_capacity: "Capacité juridique :",
        ppe: "Personne Politiquement Exposée :",
        ppe_position: "Fonction exercée :",
        ppe_country: "Pays d'exercice de la fonction :",
        has_entourage_ppe: "Entourage Politiquement Exposé :",
        entourage_ppe_relation: "Lien entre le souscripteur et la personne politiquement exposée :",
        entourage_ppe_position: "Fonction exercée :",
        entourage_ppe_country: "Pays d'exercice de la fonction :"
      },
      documents: {
        authentication_documents: {
          title: "Documents d'authentification"
        },
        status_expiring: "Un ou plusieurs de vos documents d'authentification arrivent à expiration, veuillez télécharger un document valide.",
        status_expired: "Un ou plusieurs de vos documents d'authentification ont expiré, veuillez télécharger un document valide.",
        document_list: {
          first_document: {
            title: "1er justificatif d'identité",
            desc: [
              "Pièce d'identité en cours de validité, au choix :",
              "- Votre Carte Nationale d'Identité recto et verso",
              "- Votre Passeport pages 2 et 3"
            ]
          },
          second_document: {
            title: "2nd justificatif d'identité, différent du 1er justificatif",
            desc: [
              "Au choix :",
              "- Votre Carte Nationale d'Identité recto et verso",
              "- Votre Passeport pages 2 et 3",
              "- Carte de sejour",
              "- Permis de conduire",
              "- Livret de famille",
              "- Avis d'imposition",
              "- Extrait d'acte de naissance",
              "- Contrat de mariage",
              "- Convention de PACS"
            ]
          },
          third_document: {
            title: "Justificatif de domicile",
            desc: [
              "Facture de moins de 3 mois ou échéancier (eau, gaz, électricité, internet), quittance de loyer établie par une agence ou syndic, dernier avis d'imposition sur le revenu ou de taxe d'habitation (si moins de 3 mois), à votre nom.",
              "Si vous n'avez pas de justificatif de domicile à votre nom, vous pouvez ajouter une attestation d'hébergement, accompagnée d'un justificatif de domicile et de la pièce d'identité de votre hébergeur."
            ],
            link: "Télécharger un modèle"
          },
          fourth_document: {
            title: "RIB",
            desc: [
              "Un Relevé d'Identité Bancaire à votre nom, indiquant le code IBAN et le SWIFT ou le BIC.",
              "Il doit s'agir d'un compte bancaire français."
            ]
          },
          fifth_document: {
            title: "Facture de téléphone mobile",
            desc: [
              "Si vous n'avez pas de facture de téléphone mobile à votre nom, vous pouvez ajouter une attestation sur l'honneur pour attester que le numéro utilisé pour la signature électronique du contrat est bien le vôtre."
            ],
            link: "Télécharger un modèle"
          }
        },
        bank_details: {
          title: "Coordonnées bancaires",
          titular: "Titulaire",
          iban: "IBAN",
          invalidIban: "Votre RIB est invalide, veuillez le corriger",
          rib_not_editable: "Afin de changer le compte courant lié à votre contrat, merci de prendre contact avec nos conseillers (<a href=\"mailto:conseiller@wesave.fr\">conseiller@wesave.fr</a>)"
        },
        proofs_docs: {
          layout: {
            step1_default: "Chargez vos justificatifs",
            step1_label: "Étape 1",
            step2_default: "Renseignez le type de justificatif",
            step2_label: "Étape 2",
            number_of_files: "Liste des fichiers",
            add_file: "Ajouter un fichier"
          },
          first_identity: {
            title: "Justificatif d'identité (1/2)",
            subtitle: "CNI ou Passeport",
            modal: {
              title: "Pièce d'identité",
              radio_box: {
                itentier_card: {
                  title: "Carte Nationale d'Identité",
                  subtitle: "Recto et Verso"
                },
                passport: {
                  title: "Passeport",
                  subtitle: "Pages 2 et 3"
                }
              }
            }
          },
          address: {
            title: "Justificatif de domicile",
            subtitle: "De moins de 3 mois",
            modal: {
              title: "Justificatif de domicile",
              subtitle: "De moins de 3 mois",
              radio_box: {
                invoice: {
                  title: "Facture",
                  subtitle: "Gaz, eau, électricité"
                },
                timeline: {
                  title: "Échéancier",
                  subtitle: "Gaz, eau, électricité"
                },
                tax_notice: {
                  title: "Avis d'imposition",
                  subtitle: "Page 1"
                },
                council_tax_notice: {
                  title: "Avis de taxe d'habtitation",
                  subtitle: "Page 1"
                },
                rent_receipt: {
                  title: "Quittance de loyer",
                },
                accommodation_certificate: {
                  title: "Attestation d'hébergement"
                }
              }
            }
          },
          bank: {
            title: "RIB",
            subtitle: "Avec IBAN et BIC apparents 2",
            step2: "Veuillez saisir les informations relatives à votre RIB",
            modal: {
              title: "Confirmez les informations de votre RIB",
              subtitle: "Le RIB doit provenir d'un compte courant français à votre nom",
            }
          },
          invoice_mobile: {
            title: "Facture de téléphone mobile",
            subtitle: "A votre nom",
            modal: {
              title: "Facture de téléphone mobile",
              subtitle: "De moins de 3 mois"
            }
          }
        }
      },
      informations: {
        section_1: {
          title: "Bulletins de souscription"
        },
        section_2: {
          title: "Autres documents"
        },
        section_3: {
          title: "Rapports Fonds en Euros"
        },
        warning: "Les documents téléchargeables peuvent comprendre des anomalies liées à la gestion des arrondis de la part de l'assureur Suravenir."
      }
    }
  },
  project: {
    initial_amount: "Versement initial",
    current_amount: "Montant actuel",
    monthly_payments: "Versements mensuels",
    realization_of_my_project: "Réalisation de mon projet",
    goal_in_progress: "Objectif en cours de création",
    contract_date: "Date d'effet du contrat",
    amount_to_reach: "Montant à atteindre",
    time_left: "Temps restant",
    completed: "De réalisation",
    uncoherent: {
      readjustment_of_your_project: "Réajustement de votre projet",
      sentence_uncoherent_button: ["Ce projet n'est plus cohérent", "Cliquez-ici pour le réajuster"],
      buyback_sentence: "Vous avez effectué un rachat exceptionnel. Pour maintenir la faisabilité de ce projet, il vous faut modifier son horizon de placement pour qu'il reste cohérent sur la durée",
      init_sentence: "Une opération (versement, rachat) a rendu votre projet incohérent. Pour maintenir la faisabilité de ce projet, il vous faut modifier son horizon de placement pour qu'il reste cohérent sur la durée",
      recurrent_sentence: "Vous avez effectué une modification de versements programmés. Pour maintenir la faisabilité de ce projet, il vous faut modifier son horizon de placement pour qu'il reste cohérent sur la durée",
      versement_sentence: "Vous avez effectué un versement exceptionnel. Pour maintenir la faisabilité de ce projet, il vous faut modifier son horizon de placement pour qu'il reste cohérent sur la durée",
      // Next line ('warning-info-sentence') needs to be called in a v-html, because it contains some HTML to be rendered.
      warning_info_sentence: "Attention, en modifiant l'horizon de placement de votre projet, celui-ci pourrait ne plus être en adéquation avec votre profil de risque. Pour plus d’informations, contactez votre conseiller par téléphone au <strong>01 80 49 70 00</strong> ou par email à l'adresse <strong>conseiller@wesave.fr</strong>",
      new_horizon: "Nouvel horizon",
      new_objective: "Nouvel objectif",
    },
    in_validation: {
      title: "Dossier en cours de validation",
      subtitle: "Avant de pouvoir commencer la gestion de votre projet, il doit être validé par WeSave et par notre partenaire assureur.",
      disclaimer: "*Le versement initial prend effet au plus tard le 2ème jour ouvré suivant la date de réception de la demande par Suravenir, sous réserve de la réception de l'ensemble des pièces justificatives et de l'encaissement effectif des fonds.",
      step1: {
        title: "WeSave",
        desc: "Votre dossier est en cours de validation",
        delay: "Délai de traitement maximum: <strong>J+1 ouvré</strong>",
      },
      step2: {
        title: "Partenaire Assureur",
        desc: "Votre dossier est en cours de validation",
        delay: "Délai de traitement maximum: <strong>J+2 ouvrés*</strong>"
      },
      missing_vouchers: {
        title: "WeSave",
        desc: "Pièces justificatives manquantes ou invalides.",
        button: "Cliquez-ici pour les mettre à jour.",
      },
      validated: {
        title: "WeSave",
        desc: "Votre dossier a été validé",
      }
    },
    modals: {
      cancel: {
        title: "Suppression de votre objectif",
        ask_confirmation: "Êtes vous sûr de vouloir supprimer cet objectif ?",
        remove: "Annuler cet objectif",
        conserve: "Conserver cet objectif",
      }
    },
    form: {
      header: {
        title: "Les contrats de la gamme WeSave",
        desc: "Suite à la définition de votre projet d'épargne, nous vous proposons de souscrire à l'un de nos deux contrats disponibles : le contrat d'assurance-vie WeSave Patrimoine, ou le contrat de capitalisation WeSave Patrimoine Capi.",
        link: {
          desc: "Consultez les informations liées à ces deux contrats sur",
          title: "notre page dédiée"
        }
      },
      nav: {
        step1: "Contrat<br>WeSave Patrimoine",
        step2: "Mandat<br>de gestion",
        step3: "Téléchargement<br>justificatifs"
      },
      payments: {
        title: "Confirmation des versements",
        initial_payment: "Versement initial :",
        monthly_payment: "Effort mensuel d’épargne :",
        button_change_objective: "Modifier votre objectif ?",
        risk_profile: "",
        amount_to_reach: "Mon objectif :",
        investment_period: "Ma période d’investissement :",
        desc: {
          without_monthly_payment: "Votre versement initial se fait par prélèvement automatique SEPA,",
          with_monthly_payment: "Vos versements, initial et programmés, se font par prélèvements automatiques SEPA,",
          global: "sur votre compte bancaire dont vous nous avez communiqué le RIB. <strong>WeSave n'encaisse jamais de fonds de la part de ses clients</strong>, toutes vos opérations de versement se font à l'ordre exclusif de l'assureur."
        },
        select_label: {
          monthly_deposit_date: "Jour de prélèvement",
          fund_source: "Origine des fonds versés",
          payment_account: ""
        }
      },
      allocation_portfolio_detail: {
        title: "",
        subtitle: "",
        checkbox_accept_desc: "",
        assets: {
          fixed_income: "",
          equity: ""
        }
      },
      documents_profile: {
        title: "Confirmation du profil de gestion de votre mandat d'arbitrage",
        desc_range_risk: "Nous vous avions conseillé un profil de gestion entre <strong>{start} et {end}</strong>.",
        desc_selected_risk: "Vous avez choisi <strong>le profil n°{selected} : {name}</strong>, dont voici l'allocation:",
        checkbox_label: {
          ok: "En poursuivant, je reconnais avoir pris connaissance et compris le profil de gestion qui m’est proposé. Je souhaite suivre le conseil en investissement qui m’est donné.",
          under: "En poursuivant, je reconnais avoir pris connaissance et compris le profil de gestion que j’ai choisi.",
          over: "En poursuivant, je reconnais avoir pris connaissance, et compris, que le risque du profil de gestion que je prends est plus élevé que le profil de risque que WeSave a déterminé. Par conséquent, je m'expose potentiellement à de plus fortes pertes en capital.",
        },
        risk_appetite_over: "D’après vos réponses aux questions et l’horizon de placement déterminé, ce profil de gestion ne correspond pas à votre profil de risque. Le niveau de risque et de volatilité sont effectivement plus élevés et pourraient engendrer un désinvestissement prématuré de votre part en cas de fortes fluctuations sur les marchés financiers. De plus, si votre horizon de placement est trop limité, vous pourriez subir de fortes pertes en cas de retournement des marchés, sans avoir le temps nécessaire d’y remédier.",
        understand_etf: "J'ai bien compris que les ETF sont des supports d'investissement n'offrant pas de capital garanti. En effet, l'investissement au travers d'ETF implique un risque de perte en capital."
      },
      management_mandate: {
        checkbox_confirm_next: "En poursuivant la souscription, je confirme avoir bien pris connaissance de toutes les informations relatives à mon contrat et avoir assimilé les conséquences de mes décisions d'investissement."
      },
      navigation: {
        button_contractual_condition: {
          next: "Continuer vers la confirmation de mon mandat de gestion"
        },
        button_management_mandate: {
          next: "Continuer vers les justificatifs"
        },
        button_deposit_confirmation: {
          next: "Passer à la signature électronique de la demande de souscription au contrat {contract_name}"
        },
        button_step3: {
          change_goal: "",
          next: "Passer à la signature électronique de la demande de souscription au contrat {contract_name}"
        }
      },
      complexe_allocation_donus: {
        uc: 'UC'
      },
      contractual_condition: {
        title: "Conditions contractuelles",
        desc: "Merci de prendre connaissance des conditions contractuelles de votre contrat {contract_name} ainsi que des conditions générales d'accès au service de signature électronique :",
        download_button: "Télécharger le PDF",
        checkbox_valid_contract: "Je déclare avoir pris connaissance des documents précédents, les avoir enregistrés et/ou imprimés pour pouvoir m'y reporter ultérieurement et les accepter sans réserve, ni conditions."
      }
    },
    project_amount: "{amount}",
    evolution: {
      title: "Évolution de mon épargne",
      target_amount: "Montant à atteindre",
      remaining_time: "Temps restant",
      risk_profil: "Profil de risque",
      number_risk_profil: "n°{level} ({name})",
      information_about_project: {
        title: "Informations sur mon projet",
        table: {
          headers: {
            fiscal_enveloppe: "Enveloppe fiscale",
            contract_number: "N° Contrat",
            performance: "Performance de gestion",
            progress: "Réalisation de l'objectif",
            latent_values: "+ / - values latentes",
            cash: "Épargne atteinte",
            effect_date: "Date d'effet",
            initial_transfer: "Versement initial",
            contract_status: "Statut du contrat",
            scheduled_oprations: "Versements programmés",
            cosubscription: "Co-Souscription",
            last_year: "Total versé sur les 12 derniers mois",
            risk_level: "Appétence au risque",
            total_deposits: "Total versé depuis l'origine",
            profile: "Profil mandat d'arbitrage",
            scheduled_buypack: "Rachats partiels programmés",
            target_amount: "Montant à atteindre",
            withdrawal_amount: "Total racheté depuis l'origine"
          },
          format_profil_value: "Profil n°{level} ({name})"
        }
      },
      history: {
        title: "Historique",
        tabs: {
          portfolio_evolution: {
            title: "Évolution de portefeuille",
            legend: {
              your_portfolio: "Votre portefeuille",
              transactions: "Versements / Rachats",
              target: "Profil cible"
            }
          },
          movements: {
            title: "Mouvements"
          }
        }
      },
      portfolio_allocation: "Allocation de mon portefeuille",
      geographical_distribution: "Répartition géographique",
      allocation_is_not_frozen: "L'allocation proposée ici par WeSave ne se veut pas figée dans le temps. ",
      portoflio_composition_modification: "Une modification éventuelle de sa composition se fera en fonction de votre profil d'épargnant, de vos besoins ou des évolutions de marché.",
      portfolio_fluctuation: " Nos portefeuilles évolueront en fonction de notre analyse de l'actualité, de notre sélection d'instruments financiers et de votre appétence au risque.",
      unit_linked: "Des unités de compte (UC)",
      breakdown_by_asset_class: "Votre répartition par classes d'actifs",
      update_profile_risk: {
        title: "Mettre à jour mon profil de risque",
        steps: [
          "1/ Confirmez ou modifiez les informations liées à votre profil de risque.",
          "2/ Réajustez votre projet (nom du projet, objectif et/ou durée)",
          "3/ Signez électroniquement la modification ou maintien de votre profil de risque."
        ]
      }
    },
    expert_analysis: {
      title: "Analyse experte",
      analysis: {
        title: "Répartition du portefeuille",
        title_details: "Répartition du portefeuille (détail)",
        subtitle: "Par classes d'actifs",
        headers: {
          category: "Classe d'actifs",
          date: "Date valeur",
          counter_value: "Contre valeur",
          value_part: "Valeur part",
          number_parts: "Nb de parts",
          latent_value: "+/- value latente"
        }
      }
    },
    beneficiary_clause: {
      title: "Clause bénéficiaire"
    }
  },
  buttons: {
    cancel: "Annuler",
    resume: "Continuer",
    deposit: "Versement",
    more_details: "Plus de détails",
    informations: "Informations",
    submit: "Valider",
    validation: "Validation",
    previous: "Précédent",
    next: "Suivant",
  },
  operations: {
    title: "Opérations",
    subtitle: "Effectuez un versement ou un rachat sur le projet de votre choix",
    nav_links: {
      deposit: "Versement exceptionnel",
      withdrawal: "Rachat",
      scheduled: "Versements programmés",
      history: "Historique",
    },
    deposit: {
      questions: {
        need_to_select: "Avant de procéder à la validation de ce versement exceptionnel, veuillez choisir parmi les situations suivantes",
        need_to_update: "Avant de procéder à la validation de ce versement exceptionnel, merci de mettre à jour votre profil utilisateur",
        choice_1: "J'atteste que mes informations personnelles, professionnelles et patrimoniales sont à jour.",
        choice_2: "Je souhaite mettre à jour certaines de mes informations personnelles, professionnelles et/ou patrimoniales.",
      },
      sentences: {
        holder: "Titulaire",
        available_soon: "Bientôt disponible",
        activation_delay: "Si les informations sont incorrectes, merci de prendre contact avec votre conseiller",
        SEPA: "Prélèvement SEPA",
        transfer: "Virement bancaire",
        update_infos: "Mettre à jour mes informations personnelles, professionnelles et/ou patrimoniales.",
        well_update_infos: "J'atteste avoir bien mis à jour mes informations",
        sign: "Signer électroniquement ma demande de versement exceptionnel",
        modify_my_profil: {
          title: "Modification de votre profil épargnant",
          button: "Procéder aux modifications de mon profil épargnant",
        }
      },
      sections: [
        {
          title: "Sélectionnez votre projet d'épargne",
          subtitle: "Choisissez le projet sur lequel vous souhaitez effectuer un versement.",
          pending: "Opération en cours de validation",
        },
        {
          title: "Entrez le montant à verser",
        },
        {
         title: "Indiquez l'origine de vos fonds versés",
        },
        {
          title: "Vérifiez votre moyen de paiement",
        }
      ]
    },
    withdrawal: {
      questions: {
        need_to_select: "Avant de procéder à la validation de ce rachat, veuillez choisir parmi les situations suivantes",
        need_to_update: "Avant de procéder à la validation de ce rachat, merci de mettre à jour votre profil utilisateur",
        choice_1: "J'atteste que mes informations personnelles, professionnelles et patrimoniales sont à jour.",
        choice_2: "Je souhaite mettre à jour certaines de mes informations personnelles, professionnelles et/ou patrimoniales.",
      },
      sentences: {
        update_infos: "Mettre à jour mes informations personnelles, professionnelles et/ou patrimoniales.",
        signWithdrawal: "Signer électroniquement ma demande de rachat",
        modify_my_profil: {
          title: "Modification de votre profil épargnant",
          button: "Procéder aux modifications de mon profil épargnant",
        },
      },
      sections: [
        {
          title: "Sélectionnez votre projet d'épargne",
          subtitle: "Choisissez le projet sur lequel vous souhaitez effectuer un rachat.",
          pending: "Opération en cours de validation",
        },
        {
          title: "Sélectionnez le type de rachat",
          options: ['Partiel', 'Total']
        },
        {
          title: "Entrez le montant souhaité",
        },
        {
          title: "Choisissez la fiscalité",
          options: [
            "Intégration des plus-values à l'impôt sur le revenu",
            "Prélèvement Forfaitaire Libératoire (PFL)",
          ]
        }
      ],
      disclaimer: "Attention le contrat P0 n’étant plus commercialisé par Wesave, vous n’aurez plus accès à ce contrat en cas de rachat total.",
    },
    scheduled: {
      title: "Opérations programmées en cours",
      scheduled_payment: "Versement programmé",
      payment_day: "Jour de prélèvement",
      warning_validation: "La modification de vos versements programmés est en cours de validation.",
      warning_validation_update: "En remplacement de vos versements actuels de {amount} €, prélevés le {date}",
      warning_cancel: "Vous êtes sur le point d'annuler votre versement programmé de {amount}€ / mois.",
      ask_password: "Pour valider l'opération, veuillez saisir votre mot de passe :",
      create: "Créer un versement programmé",
      disclaimer: "En cas de modifications, veuillez contacter un conseiller au <span>01 80 49 70 00</span> ou sur <a href='mailto:conseillers@wesave.fr'>conseillers@wesave.fr</a> avant de continuer.",
      suspend: "Suspendre",
      validation_box_sentence: "En poursuivant, J'atteste que mes informations personnelles, professionnelles et patrimoniales sont à jour.",
      no_operations: "Vous n'avez aucune opération programmée en cours.",
      warning_info: "Afin d'être prise en compte sur le mois en cours, toute modification d'opération programmée doit être effectuée 10 jours avant la date de prélèvement/rachat.",
    },
    history: {
      project: "Projet",
      type: "Type",
      state: "État",
    }
  },
  subscription: {
    subtitle: "Le recueil d'informations ci-dessous est effectué dans votre intérêt afin de vous fournir le conseil le plus adapté à votre situation. <strong>Par conséquent, les informations doivent être fournies d'une manière complète et sincère.",
    subtitle_cant_edit: "Certaines modifications de vos informations personnelles sont désactivées, et ne sont possibles qu'en contactant votre conseiller WeSave.",
    title: "Complétez votre profil d'épargnant",
    warning_message: "Si l'une de ces informations n'est plus à jour, veuillez la modifier.",
    personal_details: {
      nav_title: "À propos <br> de moi",
    },
    documents: {
      contractual_conditions: "Conditions contractuelles {contract_name}",
      electronic_signature_service_access_conditions: "Conditions générales d'accès au service de signature électronique",
      key_information_document: "Document d'Informations Clés {contract_name}"
    },
    financial_experience: {
      title: "Expérience en matière financière",
      subtitle: "Renseignez votre expérience en matière d’épargne. Vous pouvez cocher plusieurs réponses.",
      saving_usage: {
        select_box: {
          placeholder: "Sélectionnez une fréquence"
        },
        instructions: {
          title: "Fréquence d'utilisation",
          subtitle: "En moyenne, vous investissez/arbitrez ce type de support au minimum :"
        }
      },
      note: "Les questions suivantes permettent de déterminer vos expériences et comportements en matière de produits financiers d’une part, et de risque d’autre part :",
      finance_xp_slider: {
        first_slide: {
          question: "Depuis quand possédez-vous des investissements sur des produits financiers ?",
          note: "Un seul choix possible",
          choice_1: "Moins d’1 an",
          choice_2: "Entre 1 an et 5 ans",
          choice_3: "Depuis plus de 5 ans",
          choice_4: "Je n’ai jamais possédé d’investissements sur des produits financiers",
          help: "Les investissements sur les produits financiers peuvent être réalisés via un PEA, Comptes-titres, une assurance-vie multisupports …"
        },
        second_slide: {
          question: "En matière d’épargne, pensez-vous plutôt que :",
          note: "Un seul choix possible",
          choice_1: "Il ne faut pas prendre de risque, on doit placer toutes ses économies dans des placements sûrs",
          choice_2: "On peut placer une petite partie de ses économies sur des placements risqués",
          choice_3: "Pour espérer une bonne performance il faut accepter la prise de risque et placer la majorité de son épargne sur des placements risqués.",
          choice_4: "Je ne sais pas",
          help: "Les capitaux investis dans des placements sûrs sont garantis par l’Etat (par exemple le Livret A).",
          alt: {
            question: "Suivant quel type/mode de gestion avez-vous déjà réalisé vos investissements sur des produits financiers ?",
            note: "Plusieurs choix possibles",
            choice_1: "Gestion libre",
            choice_2: "Gestion conseillée",
            choice_3: "Gestion sous mandat",
            choice_4: "Je ne sais pas",
            help: "En gestion libre, vous allouez votre épargne comme vous le souhaitez; en gestion conseillée, vous passez les ordres en suivant, ou pas, les conseils d’un professionnel; en gestion sous mandat, un professionnel alloue votre épargne sans vous consulter au préalable avant chaque mouvement.",
          }
        },
        third_slide: {
          question: "Avez-vous déjà été en situation de pertes sur vos placements financiers ?",
          note: "Un seul choix possible",
          choice_1: "Non, je n’ai jamais été en situation de pertes",
          choice_2: "Oui, de 10% maximum",
          choice_3: "Oui, de 20% maximum",
          choice_4: "Oui, de plus de 20%",
          help: "Il est important de connaître son comportement face aux pertes pour ne pas agir de manière inadaptée."
        },
        fourth_slide: {
          question: "Quelle serait votre réaction dans l’hypothèse où votre investissement perdrait 40% de sa valeur ?",
          note: "Un seul choix possible",
          choice_1: "Réinvestir des fonds",
          choice_2: "Patienter sans être inquiet",
          choice_3: "Liquider une partie de vos investissements pour limiter les pertes",
          choice_4: "Liquider la totalité de vos investissements et subir définitivement vos pertes.",
          help: "Les pertes ne sont définitives qu’une fois les actifs revendus.",
          alt: {
            question: "Quelle a été votre réaction face à ces pertes ?",
            note: "Un seul choix possible",
            choice_1: "Réinvestir des fonds",
            choice_2: "Patienter sans être inquiet",
            choice_3: "Liquider une partie de vos investissements pour limiter les pertes",
            choice_4: "Liquider vos investissements et subir définitivement vos pertes",
            help: "Les pertes ne sont définitives qu’une fois les actifs revendus.",
          },
        },
        fifth_slide: {
          title: "Formulaire complété ! Vos réponses vont nous permettre de déterminer votre profil.",
          subtitle: "Retournez en arrière pour modifier vos choix."
        },
        page_navigation: {
          previous_step: "Précédent : Situation financière",
          next_step: "Suivant : Mon objectif d'épargne"
        },
      },
      page_navigation: {
        previous_step: "Précédent : Situation financière",
        next_step: "Suivant : Mon objectif d'épargne"
      }
    },
    finance_xp: {
      nav_title: "Connaissance <br>et expérience",
      title: "Connaissances en matière financière",
      subtitle: "Les questions suivantes permettent d'évaluer vos connaissances financières",
      finance_knowledge_slider: {
        first_slide: {
          question: "D'après vous, un ETF est-il un placement à capital garanti ?",
          note: "Un seul choix possible",
          choice_1: "Oui",
          choice_2: "Non",
          choice_3: "Je ne sais pas",
          help: "Le mode de gestion définit à quel point vous déléguez la gestion de votre épargne"
        },
        second_slide: {
          question: "D’après vous, la gestion sous mandat signifie que :",
          choice_1: "Vous validez ou non les conseils d’arbitrage qui vous sont proposés",
          choice_2: "Vous déléguez totalement la gestion de votre contrat",
          choice_3: "Vous réalisez les arbitrages que vous désirez sans recevoir de conseils",
          choice_4: "Je ne sais pas",
          help: "Le mode de gestion définit à quel point vous déléguez la gestion de votre épargne.",
          help_link: "Le mode de gestion définit à quel point vous déléguez la gestion de votre épargne."
        },
        third_slide: {
          title: "Formulaire complété ! Vos réponses vont nous permettre de déterminer votre profil.",
          subtitle: "Retournez en arrière pour modifier vos choix."
        }
      },
    },
    financial_risk_profil: {
      title: "",
      subtitle: ""
    },
    financial_situation: {
      nav_title: "Situation <br> financière",
      title: "Situation financière et juridique",
      subtitle: "Complétez votre situation financière et patrimoniale",
      annual_savings_capacity: "Capacité d’épargne annuelle :",
      source_of_revenue: "Source de revenus :",
      annual_net_household_income: "Revenus annuels nets de votre foyer :",
      estimate_your_patrimony: "Estimation de votre patrimoine :",
      estimate_bills: "À combien estimez-vous vos charges fixes (loyer(s), crédit(s), pension(s))",
      enought_cash_in_case_of: {
        question: "MISSING TRAD",
        options: [
          "MISSING TRAD",
          "MISSING TRAD",
          "MISSING TRAD",
          "MISSING TRAD",
          "MISSING TRAD",
        ]
      },
      sentence_slider: "Répartition de votre patrimoine<br>(Déplacez les curseurs selon la répartition de vos différents patrimoines)",
      previous_button: "Précédent : À propos de moi",
      next_button: "Suivant : Expérience financière",
    },
    identity: {
      nav_title: "Informations <br> personnelles",
      title: "Informations personnelles",
      title_family: "Représentant légal de l'enfant",
      subtitle: "Renseignez votre identité ainsi que vos coordonnées.",
      next_button: "Suivant : À propos de moi"
    },
    risk_profile: {
      step_title: "Complétez votre profil d'épargnant",
      title: "Votre profil de risque",
      subtitle: "Suite aux informations renseignées, voici ce que nous vous recommandons :",
      subtitle_not_subscription: "Suite aux informations apportées, voici ce que nous vous recommandons :",
      steps: {
        profile: {
          your_profile: "Votre profil",
          your_current_profile: "Votre profil actuel",
          subtitle: "Vous aviez retenu un <b>profil {profileNb} : {profileName}</b> pour votre projet d'épargne",
          subtitle_bis: "Vous aviez retenu un <b>profil {profileNb} : {profileName}</b> pour la simulation initiale de votre projet d'épargne",
          amount_to_reach: "Montant à atteindre",
          investment_period: "Ma durée d'investissement",
          my_initial_payment: "Mon versement initial",
          my_scheduled_payments: "Mes versements mensuels",
        },
        profile_esg: {
          title: "Votre profile ESG",
          subtitle: "Préférence ESG :",
          title_gauge_left: "Investissement durable dans des activités environnementales",
          title_gauge_right: "Investissement durable contribuant à des objectifs sociaux et/ou environnementaux",
          title_preferred_themes: "Thématiques préférentielles",
          chart: {
            sentence: "Vous souhaitez une approche durable globale",
          },
          help: "<strong>Nous ne pouvons vous proposer aucune offre correspondant à vos préférences ESG</strong> Cependant vous pouvez toujours les modifier si vous le souhaitez ou continuer avec un contrat classique.",
          help_CTA: "Modifier mes préférences ESG",
          recommandation: "Principium autem unde latius se funditabat, emersit ex negotio tali. Chilo ex vicario et coniux eius Maxima nomine, questi apud Olybrium ea tempestate urbi praefectum, vitamque suam venenis petitam adseverantes inpetrarunt ut hi, quos suspectati sunt, ilico rapti conpingerentur in vincula, organarius Sericus et Asbolius palaestrita et aruspex Campensis.",
          selected_type_contract: "Sélectionnez le type de contrat avec lequel vous souhaitez continuer la souscription",
          label_classic_contract: "Contrat classique",
          label_esg_contract: "Contrat ESG",
          label_tooltip: "Recommandé",
          esg_status: [
            "Neutre",
            "Modéré",
            "Significative",
            "Forte"
          ],
          preferred_themes: {
            1: "Emissions de gaz à effet de serre",
            2: "Empreinte carbone",
            3: "Impact sur la biodiversité",
            4: "Consommation d’eau",
            5: "Déchets dangereux",
            6: "Respect des normes internationales (OCDE, Nations Unies)",
            7: "Exposition à des armes controversées carbone",
            8: "Egalité de rémunération",
            9: "Egalité homme femme",
          }
        },
        analysis: {
          title: "Notre analyse",
          title_after_modifs: "Notre analyse suite à vos modifications",
          subtitle: "Profil de risque :",
          reco_0: "Suite aux réponses apportées au questionnaire, vous avez une très forte aversion au risque par rapport à la moyenne constatée auprès de la majorité des épargnants. D'une façon générale, ce profil correspond à des investisseurs prudents, qui souhaitent un support d'investissement à capital garanti. <br><br> Ce profil sans risque met votre épargne à l'abri de la volatilité des marchés financiers et vous assure un rendement régulier année après année. 100% de votre épargne sera investi sur le fonds en euros.",
          reco_1: "Suite aux réponses apportées au questionnaire, vous avez une forte aversion au risque par rapport à la moyenne constatée auprès de la majorité des épargnants. D'une façon générale, ce profil correspond à des investisseurs très conservateurs qui préfèrent prendre le moins de risque possible tout en sachant que le retour sur investissement sera en conséquence, à savoir minime. <br><br> Voulant limiter les pertes, 55% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRI, présenté dans le DIC ne dépasse pas \"4\" sur l’échelle de \"1 à 7\"). 45% de votre épargne sera investi sur le fonds en euros.",
          reco_2: "Suite aux réponses apportées au questionnaire, vous avez une aversion au risque plus grande que la moyenne constatée auprès de la majorité des épargnants. D'une façon générale, ce profil correspond à des investisseurs conservateurs qui préfèrent prendre peu de risque possible tout en sachant que le retour sur investissement sera en conséquence, à savoir minime.<br><br> Voulant limiter les pertes, 60% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRI, présenté dans le DIC ne dépasse pas \"4\" sur l’échelle de \"1 à 7\"). Le reste étant investi sur le fonds en euros.",
          reco_3: "D'après vos réponses au questionnaire, votre appétence et votre aversion au risque sont équivalentes. Vous ne cherchez pas particulièrement à préserver votre capital à tout prix, de la même façon que vous ne courrez pas après un rendement élevé. Vous êtes prêts à accepter une prise de risque si celle-ci est justifiée par un retour sur investissement en conséquence.<br><br> Ainsi, 65% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRI, présenté dans le DIC ne dépasse pas \"4\" sur l’échelle de \"1 à 7\"). 35% de votre épargne sera investie sur le fonds en euros.",
          reco_4: "D'après vos réponses au questionnaire, votre appétence et votre aversion au risque sont équivalentes. Vous ne cherchez pas particulièrement à préserver votre capital à tout prix, de la même façon que vous ne courrez pas après un rendement élevé. Vous êtes prêts à accepter une prise de risque si celle-ci est justifiée par un retour sur investissement en conséquence.<br><br> Ainsi, 70% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRI, présenté dans le DIC ne dépasse pas \"4\" sur l’échelle de \"1 à 7\"). 30% de votre épargne sera investie sur le fonds en euros.",
          reco_5: "D'après vos réponses au questionnaire, votre appétence et votre aversion au risque sont équivalentes. Vous ne cherchez pas particulièrement à préserver votre capital à tout prix, de la même façon que vous ne courrez pas après un rendement élevé. Vous êtes prêts à accepter une prise de risque si celle-ci est justifiée par un retour sur investissement en conséquence.<br><br> Ainsi, 75% de votre épargne sera majoritairement investie sur des fonds (ETF) à niveau de risque faible ou modéré (dont l’indice SRI, présenté dans le DIC ne dépasse pas \"4\" sur l’échelle de “1 à 7\"). Le reste étant investi sur le fonds en euros.",
          reco_6: "Vous faites partie des investisseurs ayant une forte appétence au risque. Vous êtes conscient que votre capital peut fluctuer à la hausse comme à la baisse dans de fortes proportions. De même que vous acceptez cette prise de risque pour espérer des gains plus importants.<br><br> 80% de votre épargne sera investie sur des Unités de compte dont le niveau de risque (mesuré par l’indice SRI présenté dans le DIC du fonds) fluctuera selon les phases de marchés. Néanmoins, 20% de votre épargne sera investie sur le fonds en euros.",
          reco_7: "Vous faites partie des investisseurs ayant une forte appétence au risque. Vous êtes conscient que votre capital peut fluctuer à la hausse comme à la baisse dans de fortes proportions. De même que vous acceptez cette prise de risque pour espérer des gains plus importants.<br><br> 85% de votre épargne sera investie sur des Unités de compte dont le niveau de risque (mesuré par l’indice SRI présenté dans le DIC du fonds) fluctuera selon les phases de marchés. Néanmoins, 15% de votre épargne sera investie sur le fonds en euros.",
          reco_8: "Vous faites partie des investisseurs ayant une forte appétence au risque. Vous êtes conscient que votre capital peut fluctuer à la hausse comme à la baisse dans de fortes proportions. De même que vous acceptez cette prise de risque pour espérer des gains plus importants.<br><br> 90% de votre épargne sera investie sur des Unités de compte dont le niveau de risque (mesuré par l’indice SRI présenté dans le DIC du fonds) fluctuera selon les phases de marchés. Le niveau de risque de votre portefeuille augmentera lors des phases identifiées comme positives et baissera lors des corrections de marché.",
          reco_9: "Vous souhaitez prendre des risques dans le but d'optimiser l'espérance de retour sur investissement de votre placement. Vous êtes conscient que votre placement est soumis de façon importante aux fluctuations des marchés financiers, et êtes prêt à ne pas prendre de décision hâtive en cas de forte baisse des marchés.<br><br> 95% de votre épargne sera investie sur des Unités de compte afin de dynamiser la performance de votre contrat. Le niveau de risque, mesuré par l’indice SRI présenté dans les DIC des fonds, pourra être important.",
          reco_10: "Vous souhaitez prendre des risques dans le but d'optimiser l'espérance de retour sur investissement de votre placement. Vous êtes conscient que votre placement est soumis de façon importante aux fluctuations des marchés financiers, et êtes prêt à ne pas prendre de décision hâtive en cas de forte baisse des marchés.<br><br> 100% de votre épargne sera investie sur des Unités de compte afin de dynamiser la performance de votre contrat. Le niveau de risque, mesuré par l’indice SRI présenté dans les DIC des fonds, pourra être important.",
        },
        advice: {
          title: "Notre conseil",
          content: "Vous allez maintenant avoir la possibilité de modifier et de valider le profil de risque allant de 1 à 10 que vous avez choisi pendant l'étape de simulation de votre objectif.<br> <br> Voici en <strong>vert</strong> les profils que nous vous conseillons :",
        },
        disclaimer: {
          may_be_low: "Attention, en suivant les conseils de notre analyse, vous pourriez atteindre votre objectif tout en prenant plus de risques qu'initialement prévu.",
          may_be_unrealisable: "Attention, en suivant les conseils de notre analyse, vous pourriez ne pas atteindre l'objectif initial prévu."
        },
        buttons: {
          validate: "Je confirme mon projet",
          adjust_project: "J'ajuste mon projet"
        }
      },
    },
    saving_goal: {
      nav_title: "Mon objectif <br> d'épargne",
      title: "Mon objectif d'épargne",
      subtitle: "Les questions suivantes permettent d'évaluer votre appétence au risque pour cet objectif d'épargne.",
      saving_goal_slider: {
        first_slide: {
          question: "Si vous investissiez 100 000€ dans ce projet, quelle fourchette gain/perte seriez-vous prêt à accepter :",
          choice_1: "De -5 000€ à + 5 000€",
          choice_2: "De -10 000€ à + 10 000€",
          choice_3: "De -20 000€ à + 20 000€",
          choice_4: "De -30 000€ à + 30 000€",
          help: "Une recherche de gains plus élevés entraîne une probabilité de pertes plus élevée."
        },
        second_slide: {
          question: "Quelle proportion de votre patrimoine financier (hors immobilier) représente cet investissement ?",
          choice_1: "Il représente une part supérieure à 50% de mon patrimoine financier",
          choice_2: "Il représente une part comprise entre 30 et 50% de mon patrimoine financier",
          choice_3: "Il représente une part comprise entre 10 et 30% de mon patrimoine financier",
          choice_4: "Il représente une part inférieure à 10% de mon patrimoine financier",
          help: "Le patrimoine financier se compose du Livret A, comptes courants, livrets d’épargne bancaires traditionnels, assurance-vie, comptes-titres, PEA..."
        },
        third_slide: {
          title: "Formulaire complété ! Vos réponses vont nous permettre de déterminer votre profil.",
          subtitle: "Retournez en arrière pour modifier vos choix."
        },
        final_slide: {
          title: "Formulaire complété ! Vos réponses vont nous permettre de déterminer votre profil.",
          subtitle: "Retournez en arrière pour modifier vos choix.",
        }
      },
      esg: {
        title: "Investissement durable",
        subtitle: "L'investissement durable ou responsable fait référence à des stratégies d'investissement qui visent à créer de la valeur à long terme pour les investisseurs, tout en contribuant à un environnement plus sain, à des communautés plus favorable et à des bonnes pratiques en matière de gouvernance d'entreprise.",
        initial: {
          question: "Souhaitez-vous exprimer des préférences en matière d’investissement durable sur les sujets environnementaux, sociaux et de gouvernance dans vos choix d’investissement?",
          answers: {
            yes: "Oui, je veux intégrer les sujets environnementaux, sociaux, et/ou de gouvernance dans mes choix de placements.",
            no: "Non, je n’ai pas de préférences à exprimer en matière d’investissement durable",
          },
        },
        slider: {
          first_slide: {
            question: "Parmi les différentes propositions ci-dessous, quelle approche vous correspond le plus",
            note: "Un seul choix possible",
            choices: [
              "Investir avec une prise en compte des enjeux Environnementaux, Sociaux et/ou de Gouvernance selon la politique définie par WeSave",
              "Investir dans des produits et services financiers répondant à des critères spécifiques en matière de durabilité",
            ],
            help: `
            <div>
            <strong>WeSave sélectionne des placements durables en fonction de deux critères :</strong>
            <br><br>
            <span>- Investissement dans des activités avec des objectifs environnementaux et sociaux selon une proportion minimale de 10% dans l'investissement</span>
            <br><br>
            <span>- Investissement dans des activités limitant ses impacts négatifs sur l'environnement ou la société</span>
            <br><br>
            <a>En savoir plus</a>
            </div>
            `
          },
          second_slide: {
            question: "Parmi les critères suivants, lequel ou lesquels souhaitez-vous intégrer ?",
            note: "Plusieurs choix possibles",
            choices: [
              "Investissement durable dans des activités environnementales",
              "Investissement durable contribuant à des objectifs sociaux et environnementaux",
              "Investissements dans des activités qui cherchent à réduire leurs incidences négatives sur des enjeux précis",
            ],
            help: `
            <div>
            <strong>Investissement durable dans des activités environnementales</strong>
            <br>
            <span>Activités qui agissent positivement pour l'environnement, par exemple en contribuant à l'atténuation du changement climatique, à la préservation de la biodiversité... Selon une classification des activités vertes définie par l'Union européenne</span>
            <br><br>
            <strong>Investissement durable contribuant à des objectifs sociaux et environnementaux</strong>
            <br>
            <span>Investissement qui contribue à un objectif social (lutte contre les inégalités, intégration sociale et relations de travail…) et/ou à un objectif environnemental (utilisation efficace des ressources en énergie, des matières premières, de l’eau et de la terre…)</span>
            <br><br>
            <strong>Investissement tenant compte ses incidences négatives sur des enjeux précis</strong>
            <span>
              - Investissements dans des activités qui cherchent à réduire leurs incidences négatives sur des enjeux précis.
              <br>
              - Investissement dans des produits et services financiers qui visent à réduire leurs incidences négatives sur l’environnement et la société.
            </span>
            <br><br>
            <span>Exemple : l’activité s’engage à réduire sa consommation d’eau , l'activité s'engage à mieux gérer ses déchets ou encore à réduire ses émissions de gaz à effet de serre</span>
            </div>
            `
          },
          third_slide: {
            label: "Investissement durable dans des activités environnementales",
            question: "Quelle part cet investissement doit il représenter dans votre allocation ?",
            note: "Un seul choix possible",
            choices: [
              "Minimum 5%",
              "Minimum 10%",
            ],
            help: "Les critères de cette approche sont très exigeants. A titre illustratif, le pourcentage d'alignement de l'économie européenne sur la Taxonomie est inférieur à 5% actuellement"
          },
          fourth_slide: {
            label: "Investissement durable contribuant à des objectifs sociaux et/ou environnementaux",
            question: "Quelle part cet investissement doit il représenter dans votre allocation ?",
            note: "Un seul choix possible",
            choices: [
              "Minimum 10%",
              "Minimum 15%",
            ],
          },
          fifth_slide: {
            label: "Thématiques préférentielles",
            question: "Sur quels enjeux souhaitez-vous que les effets négatifs de vos investissements soient minimisés ?",
            note: "Plusieurs choix possible",
          },
          final_slide: {
            title: "Formulaire complété ! Vos réponses vont nous permettre de déterminer votre profil.",
            subtitle: "Retournez en arrière pour modifier vos choix.",
          }
        }
      },
      page_navigation: {
        previous_step: "Précédent : Expérience financière",
        next_step: "Analyser mon profil de risque"
      }
    },
    loss_recap_popin: {
      in: "À",
      years: "ans",
      my_project: "Mon objectif",
      accumulate_payments: "Cumul avec vos versements"
    },
  },

  project_evolution_chart: {
    y_axis_title: "Valeur du portefeuille"
  },

  project_movements_table: {
    type: "Type",
    state: "État",
    gross_amount: "Montant brut",
    net_amount: "Montant net",
    operation_date: "Date d'opération",
    value_date: "Date de valeur"
  },

  cash_transfer: {
    kind: {
      first_alloc: "Allocation initiale",
      all: "Tous",
      OUV: "Ouverture du contrat",
      VEP: "Versement programmé",
      VLC: "Versement libre",
      ARV: "Arbitrage volontaire",
      ARA: "Réallocation",
      OS1: "OST avec impact fiscal",
      OS2: "OST sans impact fiscal",
      AVA: "Avance",
      ISA: "Intérêts sur avance",
      RBA: "Remboursement d'avance",
      RAP: "Rachat partiel",
      RAT: "Rachat total",
      RPP: "Rachat partiel programmé",
      RBT: "Remboursement de prime",
      REN: "Renonciation",
      DEC: "Décès",
      SEF: "Sans effet",
      FRG: "Frais de gestion",
      ENT: "Transfert entrant (epargne vers rente, chgt dépositaire)",
      SOR: "Transfert sortant (epargne vers rente, chgt dépositaire)",
      DDR: "Distribution de revenus (coupons, dividendes)",
      COT: "Cotisation (prévoyance, options Vie universelle)",
      PAB: "Participation aux bénéfices",
      PDF: "Prime de fidélité / bonus",
      VEI: "Versement intérêts",
      TPS: "Taxes et prélevements sociaux",
      HON: "Hors Nomenclature"
    }
  },

  assets: {
    actions_emergents: "Actions émergents",
    actions_europe_et_zone_euro: "Actions Europe et zone euro",
    actions_japon: "Actions Japon",
    actions_monde: "Actions Monde",
    actions_us_canada: "Actions US - Canada",
    alternatif: "Alternatif",
    fonds_euro: "Fonds Euro",
    matieres_premieres: "Matières premières",
    obligations_corporate: "Obligations corporate",
    obligations_souveraines: "Obligations souveraines"
  },

  geography: {
    europe: "Europe",
    north_america: "Amérique du Nord",
    asia: "Asie",
    south_america: "Amérique du Sud",
    africa: "Afrique",
  },

  project_movement: {
    filter_from: "Filtrer du",
    filter_to: "Jusqu'au",
    type: "Type"
  },

  layouts: {
    footer: {
      opening_time: "Du Lun. au Ven. de 9h à 18h",
    },
  },
}
